import {
  Toolbar,
  SaveButton,
  useNotify,
  useRefresh,
  useResourceContext,
  useTranslate,
} from "react-admin";
import { useNavigate } from "react-router";

const SaveError = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext();
  const navigate = useNavigate();
  const t = useTranslate();

  const onError = ({ message }) => {
    if (message.includes("plugin_inactive")) {
      return (
        notify(`resources.notifications.errors.${message}`, {
          type: "error",
          autoHideDuration: 2000,
          messageArgs: { resource: t(`resources.${resource}.name`) },
        }),
        refresh()
      );
    }
    if (message.includes("datex_error")) {
      notify("resources.notifications.errors.datex_error", {
        type: "error",
        autoHideDuration: 2000,
      });

      return navigate({
        pathname: "/error_page",
      });
    }
    if (message.includes("undefined or null")) {
      notify("resources.notifications.errors.Forbidden", {
        type: "error",
        autoHideDuration: 2000,
      });
    }

    return (
      notify(`resources.notifications.errors.${message}`, {
        type: "error",
        autoHideDuration: 2000,
      }),
      refresh()
    );
  };

  return (
    <Toolbar
      {...props}
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <SaveButton type="button" mutationOptions={{ onError }} />
    </Toolbar>
  );
};

export default SaveError;
